type Element = {
  name: string;
  children?: Element[];
  type?: string;
  suppliers?: [];
  supportedRevenue: number;
  uuid: string;
};

export const addTypeToElements = (elements: Element[], level: number = 1): Element[] => {
  return elements.map(element => {
    // Determine the type based on the level and name
    let type: string;
    if (element.name.includes('Intermediates')) {
      type = 'intermediate';
    } else {
      switch (level) {
        case 1:
          type = 'division';
          break;
        case 2:
          type = 'product group';
          break;
        case 3:
          type = 'product';
          break;
        default:
          type = 'unknown'; // Default type for any level beyond 3, can be customized
            break;
      }
    }

    // Create a new element with the added type
    const newElement: Element = { ...element, type };

    // If there are children, recursively add types to them as well
    if (newElement.children) {
      newElement.children = addTypeToElements(newElement.children, level + 1);
    }

    return newElement;
  });
}